import { httpGet } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';

export const getPrograms = async () => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/restorative-programs`);
  return await httpGet(url, {});
};
